import React from "react";
import PropTypes from "prop-types";
import modalStyle from "./Modal.module.scss";
import style from "../../../assets/css/styles.module.scss";

const renderActionButtons = (confirmDialog, messages, closeDialog) => {
  return confirmDialog ? (
    <>
      <button type="button" onClick={confirmDialog} className="ok">
        {messages?.yes || "Yes"}
      </button>
      <button type="button" onClick={closeDialog}>
        {messages?.no || "No"}
      </button>
    </>
  ) : (
    <button type="button" onClick={closeDialog}>
      {messages?.close || "Close"}
    </button>
  );
};

const Modal = ({ id, show, closeDialog, messages, customClass, customBgClass, confirmDialog, render }) => {
  return show ? (
    <div id={id}>
      <div className={`${customBgClass} ${modalStyle.fade} ${modalStyle.modalBackdrop} ${modalStyle.show}`} />
      <div
        className={`${customClass}
         ${modalStyle.fade} ${modalStyle.errorDialog} ${modalStyle.modal} ${modalStyle.show} ${style.modalInputs}`}
      >
        <div role="button" tabIndex="0" onClick={closeDialog} className={`${modalStyle.modal} ${modalStyle.show}`} />
        <div role="document" className={modalStyle.modalDialog}>
          <div className={modalStyle.modalContent}>
            <header className={modalStyle.modalHeaderWrapper}>
              <div className={modalStyle.modalHeader}>{messages?.title}</div>
              <button type="button" onClick={closeDialog} className={modalStyle.close}>
                <span aria-hidden="true">×</span>
                <span className={modalStyle.hidden} />
              </button>
            </header>
            <div className={modalStyle.modalBody}>
              {messages?.body}
              {render()}
            </div>
            <footer className={modalStyle.modalFooter}>
              {renderActionButtons(confirmDialog, messages, closeDialog)}
            </footer>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

Modal.displayName = "Modal";

Modal.defaultProps = {
  id: "",
  show: false,
  customBgClass: "",
  customClass: "",
  messages: null,
  confirmDialog: null,
  render: () => {}
};

Modal.propTypes = {
  /** Modal ID */
  id: PropTypes.string,
  /** Show or hide modal */
  show: PropTypes.bool,
  /** Class Name for background div */
  customBgClass: PropTypes.string,
  /** Main modal custom classname */
  customClass: PropTypes.string,
  /** List of needed messages to be displayed */
  messages: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string,
    close: PropTypes.string,
    yes: PropTypes.string,
    no: PropTypes.string
  }),
  /** Dialog close callback */
  closeDialog: PropTypes.func.isRequired,
  /** Dialog confirm callback */
  confirmDialog: PropTypes.func,
  /** render props function to be rendered in the modal content */
  render: PropTypes.func
};

export default Modal;
